(function () {
  if (window.RichTextScrollButtonsLoaded) return;
  window.RichTextScrollButtonsLoaded = true;

  var BUTTON_SELECTOR = '[data-rt-scroll-button]';
  var HIT_AREA_SELECTOR = '[data-rt-button-hit-area]';
  var SECTION_SELECTOR = '[id^="shopify-section-"], .shopify-section, [data-section-id]';

  function normalize(value) {
    return String(value || '')
      .trim()
      .replace(/^#/, '')
      .replace(/^shopify-section-/, '');
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value).replace(/["\\#.;?+*~':!^$[\]()=>|/@]/g, '\\$&');
  }

  function findSection(rawTarget) {
    var target = normalize(rawTarget);
    if (!target) return null;

    var exact = document.getElementById(rawTarget) || document.getElementById(target) || document.getElementById('shopify-section-' + target);
    if (exact) return exact;

    var escaped = cssEscape(target);
    var selectors = [
      '[data-section-id="' + escaped + '"]',
      '[data-rt-section-id="' + escaped + '"]',
      '[data-rt-section-anchor="' + escaped + '"]',
      '[id$="' + escaped + '"]',
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var match = document.querySelector(selectors[i]);
      if (match) return match;
    }

    return null;
  }

  function scrollToSection(section, mode, offset) {
    var top = section.getBoundingClientRect().top + window.pageYOffset - offset;

    if (mode === 'jump') {
      window.scrollTo(0, top);
      return;
    }

    window.scrollTo({
      top: top,
      behavior: 'smooth',
    });
  }

  function handleClick(event) {
    var button = event.target.closest(BUTTON_SELECTOR);
    var hitArea = event.target.closest(HIT_AREA_SELECTOR);

    if (!button && hitArea && !event.target.closest('a')) {
      button = hitArea.querySelector('a.rich-text__button');
    }

    if (!button) return;

    if (!button.matches(BUTTON_SELECTOR)) {
      if (!hitArea || event.target.closest('a')) return;

      var href = button.getAttribute('href');
      if (!href || button.getAttribute('aria-disabled') === 'true') return;

      event.preventDefault();
      window.location.href = href;
      return;
    }

    var section = findSection(button.dataset.rtScrollTarget);
    if (!section) return;

    event.preventDefault();
    scrollToSection(section, button.dataset.rtScrollMode, Number(button.dataset.rtScrollOffset || 0));

    if (section.id) {
      history.replaceState(null, '', '#' + section.id);
    }
  }

  function getSectionId(section) {
    return section.id || section.dataset.sectionId || '';
  }

  function getTargetLabel(section) {
    var id = getSectionId(section);
    var normalized = normalize(id);
    return normalized || id;
  }

  function markButtons(scope) {
    if (!window.Shopify || !window.Shopify.designMode) return;

    (scope || document).querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      var section = findSection(button.dataset.rtScrollTarget);
      button.dataset.rtScrollFound = section ? 'true' : 'false';
      button.setAttribute(
        'title',
        section
          ? '섹션 이동 대상 확인: ' + getTargetLabel(section)
          : '섹션 이동 대상 없음: ' + (button.dataset.rtScrollTarget || '')
      );
    });
  }

  function labelSections() {
    if (!window.Shopify || !window.Shopify.designMode) return;

    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      var id = getSectionId(section);
      if (!id || section.querySelector(':scope > .rt-section-anchor-label')) return;

      if (window.getComputedStyle(section).position === 'static') {
        section.style.position = 'relative';
      }

      var label = document.createElement('div');
      label.className = 'rt-section-anchor-label';
      label.textContent = 'Section: ' + getTargetLabel(section);
      label.setAttribute('aria-hidden', 'true');
      section.appendChild(label);
    });
  }

  function init(scope) {
    labelSections();
    markButtons(scope || document);
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  window.addEventListener('resize', function () {
    markButtons(document);
  });
})();
